import { render, staticRenderFns } from "./PengajuanInventaris.vue?vue&type=template&id=be975dbe"
import script from "./PengajuanInventaris.vue?vue&type=script&lang=js"
export * from "./PengajuanInventaris.vue?vue&type=script&lang=js"
import style0 from "./PengajuanInventaris.vue?vue&type=style&index=0&id=be975dbe&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports